import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type TimelineGroupBy = 'status' | 'none'

interface TimelineDisplayValues {
  groupBy: TimelineGroupBy
  showCycles: boolean
  showDependencies: boolean
  showUndated: boolean
}

interface TimelineDisplayState extends TimelineDisplayValues {
  setGroupBy: (groupBy: TimelineGroupBy) => void
  setShowCycles: (value: boolean) => void
  setShowDependencies: (value: boolean) => void
  setShowUndated: (value: boolean) => void
  reset: () => void
}

export const timelineDisplayDefaults: TimelineDisplayValues = {
  groupBy: 'status',
  showCycles: true,
  showDependencies: true,
  showUndated: true,
}

/** Timeline-only display options (design 27). Read with selectors. */
const useTimelineDisplayStore = create<TimelineDisplayState>()(
  persist(
    (set) => ({
      ...timelineDisplayDefaults,
      setGroupBy: (groupBy) => set({ groupBy }),
      setShowCycles: (showCycles) => set({ showCycles }),
      setShowDependencies: (showDependencies) => set({ showDependencies }),
      setShowUndated: (showUndated) => set({ showUndated }),
      reset: () => set(timelineDisplayDefaults),
    }),
    {
      name: 'moly-timeline-display',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)

export default useTimelineDisplayStore
